export const sanitise = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#x27;').trim();
};

export const sanitiseObject = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  const clean = {};
  for (const [key, val] of Object.entries(obj)) {
    if (typeof val === 'string') clean[key] = sanitise(val);
    else if (Array.isArray(val)) clean[key] = val.map(v => typeof v === 'string' ? sanitise(v) : v);
    else clean[key] = val;
  }
  return clean;
};
